export const checkoutBlocks = {
  QUICK_PAYMENT: "quick-payment",
  CONTACT_INFORMATION: "contact-information",
  SHIPPING_ADDRESS: "shipping-address",
  CONTINUE: "continue",
  SHIPPING_SUMMARY: "shipping-summary",
  SHIPPING_METHOD: "shipping-method",
  PAYMENT_METHOD: "payment-method",
  MARKETING: "accepts-marketing",
  CHECKOUT: "checkout",
};

export const paymentTypes = {
  PAYPAL: "paypal",
  CARD: "card",
  APPLE_PAY: "apple-pay",
};

export const paymentMethodProviders = {
  PAYPAL: "paypal",
  STRIPE: "stripe",
};

export const multiTinLookup = {
  pink: {
    title: "Pink Grind Tin",
    variantTitles: ["Pods", "Coffee"],
    availableLocations: ["UK", "EU", "US"],
  },
  silver: {
    title: "Silver Grind Tin",
    variantTitles: ["Silver Pods", "Silver Coffee"],
    availableLocations: ["UK", "EU"],
  },
  black: {
    title: "Black Grind Tin",
    variantTitles: ["Black Pods", "Black Coffee"],
    // variantTitles: ["Black Pods"],
    availableLocations: ["UK", "EU"],
  },
  poppy: {
    title: "Poppy Crew",
    variantTitles: ["Poppy Crew"],
    availableLocations: ["UK", "EU"],
  },
  shantell: {
    title: "Shantell Martin",
    variantTitles: ["Shantell Martin"],
    availableLocations: ["UK", "EU"],
  },
  kitty: {
    title: "Hello Kitty Tin",
    variantTitles: ["Hello Kitty"],
    availableLocations: ["UK", "EU"],
  },
  lazyoaf: {
    title: "Lazy Oaf Tin",
    variantTitles: ["Lazy Oaf"],
    availableLocations: ["UK", "EU"],
  },
  greenday: {
    title: "Green Day Tin",
    variantTitles: ["Green Day"],
    availableLocations: ["UK", "EU"],
  },
  christmas: {
    title: "Christmas Tin",
    variantTitles: ["Christmas"],
    availableLocations: ["UK", "EU"],
  },
  sophy: {
    title: "Sophy Hollington",
    variantTitles: ["Sophy Hollington"],
    availableLocations: ["UK", "EU"],
  },
  clueless: {
    title: "Clueless Tin",
    variantTitles: ["Clueless"],
    availableLocations: ["UK", "EU"],
  },
  peanuts: {
    title: "Peanuts Tin",
    variantTitles: ["Peanuts"],
    availableLocations: ["UK", "EU"],
  },
  trio: {
    title: "Grind Tin Trio",
    variantTitles: ["Grind Tin Trio"],
    availableLocations: ["UK", "EU"],
  },
  pikachu: {
    title: "Pikachu Tin",
    variantTitles: ["Pikachu"],
    availableLocations: ["UK"],
  },
  eevee: {
    title: "Eevee Tin",
    variantTitles: ["Eevee"],
    availableLocations: ["UK"],
  },
  mew: {
    title: "Mew Tin",
    variantTitles: ["Mew"],
    availableLocations: ["UK"],
  },
  pokemon: {
    title: "Pokémon Tin Collection",
    variantTitles: ["Pokémon Tin Collection"],
    availableLocations: ["UK"],
  },
  matchatin: {
    title: "Matcha Tin",
    variantTitles: ["Matcha Tin", "One tin per matcha bundle."],
    availableLocations: ["UK"],
  },
  matchakit: {
    title: "Matcha Kit",
    variantTitles: ["Matcha Tin Kit"],
    availableLocations: ["UK"],
  },
  miffy: {
    title: "Miffy Tin",
    variantTitles: ["Miffy"],
    availableLocations: ["UK"],
  },
};
